import React from 'react';
import { StatNumber } from './StatNumber';
import icon from '../images/icon-4.svg';

export const Stats = () => {
    return (
        <div className='stats stats-container'>
            <div className="icon-4"><img src={icon} alt="Process Icon" /></div>
            <div className="container">
                <h3>Powered by <span className='g-green'>Strategy,</span> Backed by <span className='g-green'>Results.</span></h3>
                <p className='para'>
                    Through our 100% organic growth engine, we’ve achieved:
                </p>
                <div className="row listing">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                        <div className="single-stats">
                            <StatNumber
                                value={150}
                                suffix={"M+"}
                            />
                            <p>Views Generated</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                        <div className="single-stats">
                            <StatNumber
                                prefix='$'
                                value={500}
                                suffix={"K+"}
                            />
                            <p>Revenue Generated</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                        <div className="single-stats">
                            <StatNumber
                                value={25}
                                suffix={"+"}
                            />
                            <p>Businesses Scaled</p>
                        </div>
                    </div>
                </div>

                <div className="stats-line"></div>
            </div>
        </div >
    )
}
